import { HoveredComp, HoveredOrg, HoveredRMR } from "../../types/marker-types";

export function OrganizationName({
    entity
}: {
    entity: HoveredOrg | HoveredComp | HoveredRMR;
}) {
    const name = 'shortName' in entity ? entity.shortName : entity.name;

    return (
        <div className="card popup-animated card--narrow">
            <div className="card-top card--narrow">
                <span className="card-top__org-title card-narrow">
                    {name}
                </span>
            </div>
        </div>
    );
}